import { call, put } from "redux-saga/effects";
import * as types from "../consts";
import {getProductList } from "../api";

// -------------------------------PRODUCT-------------------------------------------

export function* getProductListSaga({ payload }: ReturnType<typeof Object>) {
    try {
      const productList: object = yield call(getProductList, payload);
      yield put({ type: types.GET_PRODUCT_LIST_SUCCESS, response: productList });
    } catch (error) {
      yield put({ type: types.GET_PRODUCT_LIST_ERROR, error });
    }
}
